import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map, switchMap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
declare var gtag;

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  private environment = environment;
  default_title = environment.appName;
  public titles = {};

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private title: Title,
    private translateService: TranslateService
  ) {
    this.translateService.get([
    'routeTitles.login',
    'routeTitles.recovery',
    'routeTitles.changePassword',
    'routeTitles.about',
    'routeTitles.beneficiaries',
    'routeTitles.faq',
    'routeTitles.id4',
    'routeTitles.id5',
    'routeTitles.serviceIndex',
    'routeTitles.serviceDetails',
    'routeTitles.serviceAvailability',
    'routeTitles.serviceRequest',
    'routeTitles.contact',
    'routeTitles.feature',
    'routeTitles.sociosanitary',
    'routeTitles.personalArea',
    'routeTitles.personalAreaMyData',
    'routeTitles.personalAreaMyServices',
    'routeTitles.personalAreaMyBeneficiaries',
    'routeTitles.personalAreaRequestDetails',
    'routeTitles.personalAreaStockDetails',
    'routeTitles.vipSearchAirport',
    'routeTitles.vipTerminalDetails',
    'routeTitles.vipResourceDetails',
    'routeTitles.vipCheckAvailability',
    'routeTitles.vipForm',
    'routeTitles.forceError',
    'routeTitles.esimCheckAvailability',
    'routeTitles.esimForm',
    'routeTitles.transferCheckAvailability',
    'routeTitles.transferForm'
    ], {})
    .subscribe(translations => {
      this.titles = translations;
    });
  }

  boot() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.activeRoute),
      map(route => route.firstChild),
      switchMap(route => route.data),
      map((data) => {
        return data && data.title && this.titles[data.title] ? `${this.titles[data.title]} • ${this.default_title}` : this.default_title;
      })
    ).subscribe((current_title) => {
      this.title.setTitle(current_title);
    });
  }

  setTitle(title) {
    this.title.setTitle(title + ' • ' + this.default_title);
  }
}
